import { ReactNode, useEffect, useState } from 'react';
import { PATH } from '../../constants';
import { me } from '../../test.data';
import Button from '../button/v2/button';
import Container from '../containers/container';
import BrandIcon from '../icons/brand.icon';
import Avatar from '../images/avatar';
import { HStack } from '../layouts/stack.layout';
import TextLinkWrapper from '../link/text-link-wrapper';
import MobileNavigationList from '../lists/mobile-navigation.list';
import MobileProfileList from '../lists/mobile-profile.list';
import Search from '../overlay/search';

export default function MobileNavigation({
  className,
}: {
  className?: string;
}) {
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    showMenu || showProfile || showProfile
      ? document.querySelector('body')?.classList.add('no-scroll')
      : document.querySelector('body')?.classList.remove('no-scroll');
  }, [showProfile, showMenu, showSearch]);

  const toggleMenu = () => {
    // reset other overlays
    setShowProfile(false);
    setShowSearch(false);
    // toggle curr overlay
    setShowMenu((prev) => !prev);
  };
  const toggleSearch = () => {
    // reset other overlays
    setShowMenu(false);
    setShowProfile(false);
    // toggle curr overlay
    setShowSearch((prev) => !prev);
  };
  const toggleProfile = () => {
    // reset other overlays
    setShowMenu(false);
    setShowSearch(false);
    // toggle curr overlay
    setShowProfile((prev) => !prev);
  };
  const closeAll = () => {
    setShowMenu(false);
    setShowSearch(false);
    setShowProfile(false);
  };

  return (
    <Container extensions="w-full">
      <Container extensions={`${className || ''} w-full`}>
        <HStack justify="between" extensions="items-center w-full">
          <HStack extensions="w-5/12">
            <Button
              onClick={toggleMenu}
              asIcon="menu"
              size="md"
              color="secondary"
            />
          </HStack>
          <HStack justify="center" extensions="w-2/12 items-center">
            <TextLinkWrapper onClick={closeAll} to={PATH.HOME}>
              <BrandIcon />
            </TextLinkWrapper>
          </HStack>
          <HStack justify="end" extensions="w-5/12">
            <HStack extensions="items-center" gap="md">
              <Container>
                <Button
                  onClick={toggleSearch}
                  asIcon="search"
                  size="md"
                  color="secondary"
                />
              </Container>
              <Container
                onClick={toggleProfile}
                extensions="w-[40px] h-[40px] squircle"
              >
                <Avatar size="xs" url={me.avatar} alt={`me`} />
              </Container>
            </HStack>
          </HStack>
        </HStack>
      </Container>
      {showMenu && (
        <Container extensions="w-screen fixed left-0 right-0 h-full top-[4.5rem] bg-black/50 z-[100]">
          <Container extensions="w-3/4 h-[calc(100%-118px)] relative bg-[#1C1C1E] rounded-tr-3xl">
            <MobileNavigationList />
            <MobileNavigationFooterContainer>
              <Button
                withButtonStyle
                asIcon="dark-mode"
                size="base"
                color="primary"
              />
              <Button asIcon="qrcode" size="md" color="secondary" />
            </MobileNavigationFooterContainer>
          </Container>
          <Container
            extensions="w-1/4 left-3/4 top-0 absolute h-full"
            onClick={toggleMenu}
          />
        </Container>
      )}
      {showProfile && (
        <Container extensions="w-screen fixed left-0 right-0 h-full top-[4.5rem] bg-black/50 z-[100]">
          <Container
            onClick={toggleProfile}
            extensions="w-1/4 absolute top-0 left-0 h-full"
          />
          <Container extensions="w-3/4 left-1/4 h-[calc(100%-118px)] relative bg-[#1C1C1E] rounded-tl-3xl">
            <MobileProfileList close={toggleProfile} />
            <MobileNavigationFooterContainer>
              <Button asIcon="wallet" size="md" color="secondary" />
            </MobileNavigationFooterContainer>
          </Container>
        </Container>
      )}
      {showSearch && (
        <>
          <Container extensions="w-screen fixed top-[4.5rem] left-0 bottom-0 bg-black/75 backdrop-blur-lg z-[100]">
            <Container extensions="absolute w-full h-full px-5 pt-2 ">
              <Search />
            </Container>
          </Container>
          <Container
            onClick={toggleSearch}
            extensions="w-screen absolute h-screen top-[6.5rem] left-0"
          />
        </>
      )}
    </Container>
  );
}

function MobileNavigationFooterContainer({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Container extensions="fixed bottom-0 h-[3.8125rem] w-3/4 bg-[#08080D] border-t-2 border-dark-gray">
      <HStack justify="between" extensions="w-full items-center h-full px-5">
        {children}
      </HStack>
    </Container>
  );
}
